import { render } from "./updatePw.vue?vue&type=template&id=7a2bfad7"
import script from "./updatePw.vue?vue&type=script&lang=js"
export * from "./updatePw.vue?vue&type=script&lang=js"

import "./updatePw.vue?vue&type=style&index=0&id=7a2bfad7&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__